import { EnvEnum, Environment } from 'editor/src/environment/types';

const env: Environment = {
  production: false,
  env: EnvEnum.staging,
  translationsUrl: 'https://design-editor.staging.gelato.tech/translations/',
  useLokalino: true,
  amplitudeKey: '',
  shutterstockKeys: {
    essentials: 'G1PTOJzNrrvaESrDlGCeGrGpu7XdSICQ',
    full: 'nNJwspGEM8GtBdqnU2FyGk1Qcr8fQXf0',
  },
  datadogClientToken: 'pub6bef54cf4c2a51083d34400d8775f993',
};

export default env;
